import { SearchModel } from "./search.model";

export class ReasonConfigurationSearch extends SearchModel {
  category: string;
}
